import ApiBase from '../ApiBase';

class Me extends ApiBase {
    /**
     * @method getMe
     * @return {Promise<*>}
     */
    getMe = () => {
        return this.get('me');
    };

    /**
     * @method update
     * @param {object} data
     * @return {Promise<boolean|{status: number}>}
     */
    update = async (data) => {
        return this.patch('me', data, 'update');
    };

    /**
     * @method updatePassword
     * @param {object} data
     * @return {Promise<boolean|{status: number}>}
     */
    updatePassword = (data) => {
        return this.patch('me/password', data, 'update-password');
    };

    /**
     * @method updateAvatar
     * @param {object} data
     * @return {Promise<boolean|{status: number}|*>}
     */
    updateAvatar = async (data) => {
        return this.patch('me/avatar', data, 'update-avatar');
    };

    /**
     * @method updateTeam
     * @param {object} data
     * @return {Promise<boolean|{status: number}>}
     */
    updateTeam = (data) => {
        return this.patch('me/team', data, 'update-team');
    };

    /**
     * @method updateService
     * @param {object} data
     * @return {Promise<boolean|{status: number}>}
     */
    updateService = (data) => {
        return this.patch('me/service', data, 'update-service');
    };

    /**
     * @method remove
     * @param {object} data
     * @return {Promise<boolean|{status: number}>}
     */
    remove = (data) => {
        return this.delete('me', 'delete', 204, {
            data
        });
    };
}

export default new Me();
